import React, {Fragment, Component } from "react";
import PAsbStartPopup from "./PAsbStartPopup";


export default class PAsbStart extends Component {

  constructor(props) {
    super(props);
    this.state = {
      sb: 'not ready', //connected
    }
  }


  handleDisConnect = () => {
    this.setState({
      sb: 'not ready',
    })
  }

  handleConnect = () => {
    this.setState({
      sb: 'connected',
    })
  }


  render() {
    return (
      <Fragment>


        {this.state.sb === 'connected' && <PAsbStartPopup
          handleClose={this.handleDisConnect.bind(this)}
        ></PAsbStartPopup>}



        {(this.state.sb === 'not ready' || this.state.sb === 'connected') && <div className="xsui-content-block xsui-content-block--appearance-flatten">
          <div className="xsui-content-block__entry">
            <div className="xsui-content-block xsui-content-block--appearance-branding">
              <div className="xsui-content-block__entry"
                style={{minHeight: '80vh'}}
              >
                <div className="product-start-page">
                  <div className="product-start-page-title">
                    Welcome to Xsolla Site Builder
                  </div>
                  <div className="product-start-page-description">
                    Launch a customizable, secure website where you can entice
                    players to join the world of your game.
                  </div>

                  {/* <div className="site-builder-placeholder__content__confirm">
                    <div className="site-builder-placeholder__content__confirm__control">
                      <div className="xsui-checkbox xsui-checkbox--primary">
                        <div className="xsui-checkbox__wrapper">
                          <label data-value="false">
                            <input
                              className="xsui-checkbox__input"
                              type="checkbox"
                              defaultValue="false"
                            />
                            <div className="xsui-checkbox__label" />
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="site-builder-placeholder__content__confirm__control-desc">
                      <span>
                        I agree to the{" "}
                        <a
                          href="https://xsolla.com/products/site_builder/terms?_gl=1*4rtoxn*_gcl_aw*R0NMLjE1NTQ5ODEwNzIuQ2p3S0NBand5N3ZsQlJBQ0Vpd0FadmR4OW9jd3ZuMXNVVUthSUZGeFUtUDdsY1c0SkZWdl9vaERLNDhJQjFtVHRxUUUtQXpuam5EUUlCb0MxQmtRQXZEX0J3RQ.."
                          target="_blank"
                        >
                          Terms and Conditions
                        </a>
                      </span>
                    </div>
                  </div> */}

                  <div
                    className="product-start-page-btn"
                    data-id="sb_create"
                    ev="first"
                    onClick={this.handleConnect}
                  >
                    <div className="product-start-page-btn__label">
                      Create a landing page
                    </div>
                    <div className="product-start-page-btn__icon-holder">
                      <i
                        className="xsui-icon xsui-icon-add"
                        style={{ fontSize: 12, color: "inherit" }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>}
      </Fragment>
    );
  }
}
